import Crud from '../components/ContactUs/Crud'
import View from '../components/ContactUs/View'

let routes = {
    path: '/contactUs',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/contactUs',
            component: Crud
        },
        {
            path: '/contactUs/view/:id',
            component: View
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/contactUs.js